(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.dsCreviewsInit) return;
    root.dataset.dsCreviewsInit = '1';

    var list = root.querySelector('[data-creviews-list]');
    var cards = list ? Array.prototype.slice.call(list.querySelectorAll('[data-creview-card]')) : [];
    var searchInput = root.querySelector('[data-creviews-search]');
    var sortSelect = root.querySelector('[data-creviews-sort]');
    var emptyEl = root.querySelector('[data-creviews-empty]');
    var loadMoreBtn = root.querySelector('[data-creviews-load-more-btn]');
    var writeBtn = root.querySelector('[data-creviews-write-btn]');
    var formPanel = root.querySelector('[data-creviews-form]');
    var formCancel = root.querySelector('[data-creviews-form-cancel]');
    var formClose = root.querySelector('[data-creviews-form-close]');
    var formEl = root.querySelector('[data-creviews-form-el]');
    var feedbackEl = root.querySelector('[data-creviews-feedback]');
    var charCountEl = root.querySelector('[data-creviews-char-count]');
    var starBtns = root.querySelectorAll('[data-creviews-star]');
    var ratingInput = root.querySelector('[data-creviews-rating-input]');
    var modal = root.querySelector('[data-creviews-modal]');
    var modalClose = root.querySelector('[data-creviews-modal-close]');
    var modalBackdrop = root.querySelector('[data-creviews-modal-backdrop]');

    var initialCount = parseInt(root.dataset.creviewsInitial || '7', 10);
    var loadMoreCount = parseInt(root.dataset.creviewsLoadMore || '3', 10);
    if (isNaN(initialCount) || initialCount < 1) initialCount = 7;
    if (isNaN(loadMoreCount) || loadMoreCount < 1) loadMoreCount = 3;

    var visibleLimit = initialCount;

    function parseDate(str) {
      var d = Date.parse(str);
      return isNaN(d) ? 0 : d;
    }

    function getSearchQuery() {
      return searchInput ? searchInput.value.trim().toLowerCase() : '';
    }

    function getMatchingCards() {
      var query = getSearchQuery();
      return cards.filter(function (card) {
        var text = (card.getAttribute('data-search-text') || '').toLowerCase();
        return !query || text.indexOf(query) !== -1;
      });
    }

    function sortCards(matching) {
      var sort = sortSelect ? sortSelect.value : 'date_desc';
      matching.sort(function (a, b) {
        var da = parseDate(a.getAttribute('data-date') || '');
        var db = parseDate(b.getAttribute('data-date') || '');
        if (sort === 'date_asc') return da - db;
        if (sort === 'rating_desc') {
          return (
            parseInt(b.getAttribute('data-rating') || '0', 10) -
            parseInt(a.getAttribute('data-rating') || '0', 10)
          );
        }
        return db - da;
      });
      return matching;
    }

    function updateLoadMoreButton(matchingCount) {
      if (!loadMoreBtn) return;
      loadMoreBtn.hidden = matchingCount === 0 || visibleLimit >= matchingCount;
    }

    function applyPagination() {
      var matching = sortCards(getMatchingCards());

      matching.forEach(function (card) {
        list.appendChild(card);
      });

      cards.forEach(function (card) {
        var matchIndex = matching.indexOf(card);
        if (matchIndex === -1) {
          card.hidden = true;
        } else {
          card.hidden = matchIndex >= visibleLimit;
        }
      });

      if (emptyEl) {
        emptyEl.classList.toggle('is-visible', matching.length === 0);
      }

      updateLoadMoreButton(matching.length);
    }

    function resetPagination() {
      visibleLimit = initialCount;
      applyPagination();
    }

    if (searchInput) {
      searchInput.addEventListener('input', resetPagination);
    }
    if (sortSelect) {
      sortSelect.addEventListener('change', resetPagination);
    }
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        visibleLimit += loadMoreCount;
        applyPagination();
      });
    }

    function setFormOpen(open) {
      if (!formPanel) return;
      formPanel.classList.toggle('is-open', open);
      if (open) formPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    if (writeBtn) {
      writeBtn.addEventListener('click', function () {
        setFormOpen(true);
      });
    }
    if (formCancel) {
      formCancel.addEventListener('click', function () {
        setFormOpen(false);
      });
    }
    if (formClose) {
      formClose.addEventListener('click', function () {
        setFormOpen(false);
      });
    }

    function setStarRating(value) {
      if (ratingInput) ratingInput.value = String(value);
      starBtns.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i < value);
      });
    }

    starBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setStarRating(parseInt(btn.getAttribute('data-creviews-star') || '5', 10));
      });
    });
    setStarRating(5);

    if (feedbackEl && charCountEl) {
      feedbackEl.addEventListener('input', function () {
        var len = feedbackEl.value.length;
        if (len > 2000) {
          feedbackEl.value = feedbackEl.value.slice(0, 2000);
          len = 2000;
        }
        charCountEl.textContent = len + '/2000';
      });
    }

    function openModal() {
      if (modal) {
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    }

    function closeModal() {
      if (modal) {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }

    if (modalClose) modalClose.addEventListener('click', closeModal);
    if (modalBackdrop) modalBackdrop.addEventListener('click', closeModal);

    if (formEl) {
      formEl.addEventListener('submit', function (e) {
        e.preventDefault();
        setFormOpen(false);
        formEl.reset();
        setStarRating(5);
        if (charCountEl) charCountEl.textContent = '0/2000';
        openModal();
      });
    }

    var mediaBtn = root.querySelector('[data-creviews-media-btn]');
    if (mediaBtn) {
      mediaBtn.addEventListener('click', function () {
        /* UI-only — no upload */
      });
    }

    applyPagination();
  }

  function boot() {
    document.querySelectorAll('[data-ds-customer-reviews]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ds-customer-reviews]');
    if (root) initSection(root);
  });
})();
